import axios from 'axios';
import React, { Component, useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import HomePageLayouts from '../../component/Layout/HomePageLayout';
import config from '../../config';
import { getAuthHeader } from '../../utils';

export default function HomePageLayout() {

  const [response, setResponse] = useState([])
  const [feature, setFeature] = useState([])
  const compnaySubmit = (data) => {
    //   const model = {
    //     newComvacancy:Newcompany.newComvacancy,
    //     comName:Newcompany.comName,
    //     comperName:Newcompany.comperName,
    //     comEmail:Newcompany.comEmail,
    //     comPhone:Newcompany.comPhone,
    //     comAddress:Newcompany.comAddress
    //   };
    //   // props.onSubmit(model)
    console.log(data, "model");
  }
  useEffect(() => {
    fresherJobList()
    PremiumCompany()
  }, []);

  const fresherJobList = () => {
    axios.post('https://cp-api.rozgar.com/latest-campus-frehser-job', {
      filter: '',
      limit: 2,
      page: 1
    }).then((res) => {
      console.log("response", res.data.result.list)
      setResponse(res.data.result.list)
    }).catch((err) => {
      console.log("response", err)
    })
  }
  const PremiumCompany = () => {
    axios.get('https://cp-devapi.rozgar.com/rzg-top-company-images-campus').then((res) => {
      console.log("response", res.data.result.images)
      setFeature(res.data.result.images)
    }).catch((err) => {
      console.log("response", err)
    })
  }


  return (
    <React.Fragment>
      <HomePageLayouts
        compnaySubmit={(data) => compnaySubmit(data)}
        Feature={feature}
        Data={response}
      />
    </React.Fragment>
  )
}
